import {
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  TemplateRef,
  ViewChild
} from '@angular/core';
import {ThemeConstantService} from '@shared/service/theme-constant/theme-constant.service';
import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';
import {KNOWS_COOKIES} from '@shared/helpers/variables';
import {StorageService} from '@app/service/util/storage.service';
import {ToastService} from '@app/service/util/toast.service';
import {NzNotificationRef} from 'ng-zorro-antd/notification';
import {isPlatformBrowser} from '@angular/common';

@Component({
  selector: 'app-full-layout',
  templateUrl: './full-layout.component.html',
  styleUrls: ['./full-layout.component.scss']
})

export class FullLayoutComponent implements OnInit, OnDestroy {
  @ViewChild('acceptCookiesRef', {static: false}) acceptCookiesRef: TemplateRef<any>;
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  acceptCookiesToast: NzNotificationRef;
  isExpand: boolean; // Toggle the nav bar itself
  isBrowser: boolean;

  constructor(private themeService: ThemeConstantService, private cd: ChangeDetectorRef, private toast: ToastService,
              private storage: StorageService, @Inject(PLATFORM_ID) private platformId: any) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngOnInit() {
    this.themeService.isExpandChanges
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(isExpand => {
        this.isExpand = isExpand;
        this.cd.detectChanges();
      });

    // const hasSeenCookies = this.storage.retrieveValue(KNOWS_COOKIES);
    // if (!hasSeenCookies && this.isBrowser) {
    //   this.showCookiesNotification();
    // }
  }

  showCookiesNotification() {
    this.acceptCookiesToast = this.toast.templateNoCloseIcon(this.acceptCookiesRef, {
      nzKey: 'acceptCookies',
      nzDuration: 0,
      nzCloseIcon: '',
      nzPlacement: 'bottomLeft',
      nzStyle: {
        width: '1200px',
        bottom: '-48px'
      }
    });

    this.acceptCookiesToast
      .onClose
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(() => {
        this.acceptCookies(null);
      });
  }

  acceptCookies(notificationRef: any) {
    this.storage.saveValue(KNOWS_COOKIES, true);
    if (notificationRef) {
      notificationRef.close();
    }
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
